$('.in-index .products').slick({
  slidesToShow: 4,
 slidesToScroll: 1,
 autoplay: false,
 autoplaySpeed: 3000,
 dots: true,
 arrow: true,
 infinite: false,
 responsive: [
   {
     breakpoint: 1199,
     settings: {
       slidesToShow: 3,
       slidesToScroll: 1,
       arrow: true,
       dots: true,
     }
   },
   {
     breakpoint: 991,
     settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrow: true,
      dots: true,
    }
    
   },
   {
     breakpoint: 650,
     settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrow: true,
      dots: true,
    }
    
   }
 ]
});

$('.p-detail .products:not(.products-alternative)').slick({
  slidesToShow: 4,
 slidesToScroll: 1,
 autoplay: false,
 autoplaySpeed: 3000,
 dots: true,
 arrow: true,
 infinite: false,
 responsive: [
  {
    breakpoint: 1199,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      arrow: true,
      dots: true,
    }
  },
  {
    breakpoint: 991,
    settings: {
     slidesToShow: 2,
     slidesToScroll: 1,
     arrow: true,
     dots: true,
   }
   
  },
  {
    breakpoint: 650,
    settings: {
     slidesToShow: 1,
     slidesToScroll: 1,
     arrow: true,
     dots: true,
   }
   
  }
]
});